import TalentosListLayer from "../../components/TalentosListLayer";

const TalentosPage = () => {
  return <TalentosListLayer />;
};

export default TalentosPage;
